export const SERVICE_URL = 'https://nouraboelsoud.com/erp/apis/v1/';
